// ESign (DocuSign-style e-signing envelopes) action types

export const ESIGN_LIST = "ESIGN_LIST";
export const ESIGN_LIST_SUCCESS = "ESIGN_LIST_SUCCESS";
export const ESIGN_LIST_FAILURE = "ESIGN_LIST_FAILURE";

export const ESIGN_DATA = "ESIGN_DATA";
export const ESIGN_DATA_SUCCESS = "ESIGN_DATA_SUCCESS";
export const ESIGN_DATA_FAILURE = "ESIGN_DATA_FAILURE";

export const ESIGN_CREATE = "ESIGN_CREATE";
export const ESIGN_CREATE_SUCCESS = "ESIGN_CREATE_SUCCESS";
export const ESIGN_CREATE_FAILURE = "ESIGN_CREATE_FAILURE";

export const ESIGN_UPDATE = "ESIGN_UPDATE";
export const ESIGN_UPDATE_SUCCESS = "ESIGN_UPDATE_SUCCESS";
export const ESIGN_UPDATE_FAILURE = "ESIGN_UPDATE_FAILURE";

export const ESIGN_DOCUMENT_UPLOAD = "ESIGN_DOCUMENT_UPLOAD";
export const ESIGN_DOCUMENT_UPLOAD_SUCCESS = "ESIGN_DOCUMENT_UPLOAD_SUCCESS";
export const ESIGN_DOCUMENT_UPLOAD_FAILURE = "ESIGN_DOCUMENT_UPLOAD_FAILURE";

export const ESIGN_SEND = "ESIGN_SEND";
export const ESIGN_SEND_SUCCESS = "ESIGN_SEND_SUCCESS";
export const ESIGN_SEND_FAILURE = "ESIGN_SEND_FAILURE";

export const ESIGN_VOID = "ESIGN_VOID";
export const ESIGN_VOID_SUCCESS = "ESIGN_VOID_SUCCESS";
export const ESIGN_VOID_FAILURE = "ESIGN_VOID_FAILURE";

export const ESIGN_DOWNLOAD = "ESIGN_DOWNLOAD";
export const ESIGN_DOWNLOAD_SUCCESS = "ESIGN_DOWNLOAD_SUCCESS";
export const ESIGN_DOWNLOAD_FAILURE = "ESIGN_DOWNLOAD_FAILURE";

export const ESIGN_DELETE = "ESIGN_DELETE";
export const ESIGN_DELETE_SUCCESS = "ESIGN_DELETE_SUCCESS";
export const ESIGN_DELETE_FAILURE = "ESIGN_DELETE_FAILURE";
